/**
 * @generated SignedSource<<141ef6ebf9efa46f80ebd9317fa4abaf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectCreateInput = {
  client_id?: number | null | undefined;
  client_name?: string | null | undefined;
  confirmed: boolean;
  custom_values?: ProjectInputCustomValues | null | undefined;
  emoji?: string | null | undefined;
  is_template: boolean;
  links?: ReadonlyArray<ProjectInputLink> | null | undefined;
  manager_ids?: ReadonlyArray<number | null | undefined> | null | undefined;
  name: string;
  pricing_model: string;
  rate_card_id: number;
  references?: any | null | undefined;
  tags?: ReadonlyArray<string | null | undefined> | null | undefined;
  team_id?: number | null | undefined;
  workstreams?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type ProjectInputCustomValues = {
  checkbox?: ReadonlyArray<ProjectInputCustomValuesCheckbox | null | undefined> | null | undefined;
  date?: ReadonlyArray<ProjectInputCustomValuesDate | null | undefined> | null | undefined;
  select?: ReadonlyArray<ProjectInputCustomValuesSelect | null | undefined> | null | undefined;
  text?: ReadonlyArray<ProjectInputCustomValuesText | null | undefined> | null | undefined;
};
export type ProjectInputCustomValuesCheckbox = {
  typeId: number;
  value: boolean;
};
export type ProjectInputCustomValuesDate = {
  typeId: number;
  value?: string | null | undefined;
};
export type ProjectInputCustomValuesSelect = {
  optionId: number;
  typeId: number;
};
export type ProjectInputCustomValuesText = {
  typeId: number;
  value: string;
};
export type ProjectInputLink = {
  href: string;
  id?: number | null | undefined;
  name: string;
  show_in_planner: boolean;
};
export type ProjectCreateMutation$variables = {
  input: ProjectCreateInput;
  todaysDate: any;
};
export type ProjectCreateMutation$data = {
  readonly action_project_create: {
    readonly account: {
      readonly clients: ReadonlyArray<{
        readonly id: number;
        readonly projects: ReadonlyArray<{
          readonly id: number;
        }>;
      }>;
      readonly id: number;
      readonly projectTemplates: ReadonlyArray<{
        readonly id: number;
      }>;
      readonly project_tags: ReadonlyArray<{
        readonly archived: boolean;
        readonly id: number;
        readonly model: string;
        readonly name: string;
      }>;
      readonly projects: ReadonlyArray<{
        readonly id: number;
      }>;
      readonly tags: ReadonlyArray<{
        readonly archived: boolean;
        readonly id: number;
        readonly model: string;
        readonly name: string;
      }>;
      readonly workstreams: ReadonlyArray<{
        readonly archived: boolean;
        readonly id: number;
        readonly name: string;
      }>;
    } | null | undefined;
    readonly project: {
      readonly account_id: number;
      readonly active: boolean;
      readonly actuals_aggregate: {
        readonly aggregate: {
          readonly count: number;
        } | null | undefined;
      };
      readonly archivable: boolean | null | undefined;
      readonly assignments_aggregate: {
        readonly aggregate: {
          readonly count: number;
        } | null | undefined;
      };
      readonly calc_end_date: string | null | undefined;
      readonly calc_start_date: string | null | undefined;
      readonly client: {
        readonly active: boolean;
        readonly id: number;
        readonly image_key: string | null | undefined;
        readonly name: string;
        readonly real_client: boolean | null | undefined;
      };
      readonly client_id: number;
      readonly confirmed: boolean;
      readonly created_at: string;
      readonly custom_checkbox_values: ReadonlyArray<{
        readonly typeId: number;
        readonly value: boolean;
      }>;
      readonly custom_date_values: ReadonlyArray<{
        readonly typeId: number;
        readonly value: any | null | undefined;
      }>;
      readonly custom_select_values: ReadonlyArray<{
        readonly optionId: number;
        readonly typeId: number;
      }>;
      readonly custom_text_values: ReadonlyArray<{
        readonly typeId: number;
        readonly value: string;
      }>;
      readonly emoji: string | null | undefined;
      readonly future_assignments_aggregate: {
        readonly aggregate: {
          readonly count: number;
        } | null | undefined;
      };
      readonly id: number;
      readonly is_template: boolean;
      readonly links: ReadonlyArray<{
        readonly href: string;
        readonly id: number;
        readonly name: string;
        readonly show_in_planner: boolean;
      }>;
      readonly managers: ReadonlyArray<{
        readonly id: number;
        readonly project: {
          readonly id: number;
        };
        readonly user_id: number;
      }>;
      readonly members: ReadonlyArray<{
        readonly id: number;
        readonly person_id: number;
      }>;
      readonly milestones: ReadonlyArray<{
        readonly date: string | null | undefined;
        readonly icon: string | null | undefined;
        readonly id: number;
        readonly note: string | null | undefined;
        readonly project_id: number;
      }>;
      readonly name: string;
      readonly other_costs: ReadonlyArray<{
        readonly charge: number;
        readonly cost: number;
        readonly date: string | null | undefined;
        readonly id: number;
        readonly project_id: number;
      }>;
      readonly phases: ReadonlyArray<{
        readonly color: string;
        readonly end_date: string | null | undefined;
        readonly id: number;
        readonly name: string;
        readonly project_id: number;
        readonly start_date: string | null | undefined;
      }>;
      readonly pricing_model: string;
      readonly pricing_model_readable: string | null | undefined;
      readonly project_rates: ReadonlyArray<{
        readonly id: number;
        readonly project_id: number;
        readonly rate: number | null | undefined;
        readonly role_id: number;
      }>;
      readonly project_roles: ReadonlyArray<{
        readonly estimated_minutes: number | null | undefined;
        readonly project_id: number;
        readonly role_id: number;
      }>;
      readonly project_workstreams: ReadonlyArray<{
        readonly workstream: {
          readonly archived: boolean;
          readonly id: number;
          readonly name: string;
        };
      }>;
      readonly rate_card: {
        readonly id: number;
        readonly role_charge_out_rates: ReadonlyArray<{
          readonly charge_out_rate: number | null | undefined;
          readonly rate_card_id: number;
          readonly role_id: number;
        }>;
      };
      readonly rate_card_id: number;
      readonly references: any;
      readonly tags: any | null | undefined;
      readonly team: {
        readonly id: number;
        readonly name: string;
      } | null | undefined;
      readonly team_id: number | null | undefined;
      readonly workstreams_computed: any | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"DetectedPeopleSection_project" | "ProjectGroupStats_project">;
    } | null | undefined;
  } | null | undefined;
};
export type ProjectCreateMutation = {
  response: ProjectCreateMutation$data;
  variables: ProjectCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "todaysDate"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "account_id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "client_id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "calc_end_date",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "calc_start_date",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created_at",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rate_card_id",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "references",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "team_id",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "confirmed",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "is_template",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tags",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "workstreams_computed",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pricing_model_readable",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pricing_model",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emoji",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "archivable",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimated_minutes",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "project_id",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role_id",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image_key",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "real_client",
  "storageKey": null
},
v26 = [
  (v2/*: any*/),
  (v3/*: any*/)
],
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "teams",
  "kind": "LinkedField",
  "name": "team",
  "plural": false,
  "selections": (v26/*: any*/),
  "storageKey": null
},
v28 = {
  "alias": "date",
  "args": null,
  "kind": "ScalarField",
  "name": "date_runn",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "note",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "icon",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "person_id",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "project_rates",
  "kind": "LinkedField",
  "name": "project_rates",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v23/*: any*/),
    (v22/*: any*/),
    {
      "alias": "rate",
      "args": null,
      "kind": "ScalarField",
      "name": "rate_private",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "archived",
  "storageKey": null
},
v34 = [
  (v2/*: any*/),
  (v3/*: any*/),
  (v33/*: any*/)
],
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "workstreams",
  "kind": "LinkedField",
  "name": "workstream",
  "plural": false,
  "selections": (v34/*: any*/),
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "concreteType": "phases",
  "kind": "LinkedField",
  "name": "phases",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "alias": "start_date",
      "args": null,
      "kind": "ScalarField",
      "name": "start_date_runn",
      "storageKey": null
    },
    {
      "alias": "end_date",
      "args": null,
      "kind": "ScalarField",
      "name": "end_date_runn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    (v22/*: any*/)
  ],
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "order_by",
      "value": {
        "date": "asc"
      }
    }
  ],
  "concreteType": "other_costs",
  "kind": "LinkedField",
  "name": "other_costs",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v22/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "charge",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cost",
      "storageKey": null
    },
    (v28/*: any*/)
  ],
  "storageKey": "other_costs(order_by:{\"date\":\"asc\"})"
},
v38 = [
  (v2/*: any*/)
],
v39 = {
  "alias": null,
  "args": null,
  "concreteType": "project_managers",
  "kind": "LinkedField",
  "name": "managers",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "user_id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "projects",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": (v38/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "concreteType": "rate_cards",
  "kind": "LinkedField",
  "name": "rate_card",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "role_charge_out_rates",
      "kind": "LinkedField",
      "name": "role_charge_out_rates",
      "plural": true,
      "selections": [
        (v23/*: any*/),
        (v10/*: any*/),
        {
          "alias": "charge_out_rate",
          "args": null,
          "kind": "ScalarField",
          "name": "charge_out_rate_private",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "concreteType": "project_links",
  "kind": "LinkedField",
  "name": "links",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "href",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "show_in_planner",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v42 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  }
],
v43 = {
  "alias": null,
  "args": null,
  "concreteType": "actuals_aggregate",
  "kind": "LinkedField",
  "name": "actuals_aggregate",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "actuals_aggregate_fields",
      "kind": "LinkedField",
      "name": "aggregate",
      "plural": false,
      "selections": (v42/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v44 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "assignments_aggregate_fields",
    "kind": "LinkedField",
    "name": "aggregate",
    "plural": false,
    "selections": (v42/*: any*/),
    "storageKey": null
  }
],
v45 = {
  "alias": null,
  "args": null,
  "concreteType": "assignments_aggregate",
  "kind": "LinkedField",
  "name": "assignments_aggregate",
  "plural": false,
  "selections": (v44/*: any*/),
  "storageKey": null
},
v46 = {
  "alias": "future_assignments_aggregate",
  "args": [
    {
      "fields": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "_gte",
              "variableName": "todaysDate"
            }
          ],
          "kind": "ObjectValue",
          "name": "end_date_iso"
        }
      ],
      "kind": "ObjectValue",
      "name": "where"
    }
  ],
  "concreteType": "assignments_aggregate",
  "kind": "LinkedField",
  "name": "assignments_aggregate",
  "plural": false,
  "selections": (v44/*: any*/),
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "concreteType": "custom_text_values",
  "kind": "LinkedField",
  "name": "custom_text_values",
  "plural": true,
  "selections": [
    (v47/*: any*/),
    {
      "alias": "typeId",
      "args": null,
      "kind": "ScalarField",
      "name": "custom_text_type_id",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "concreteType": "custom_date_values",
  "kind": "LinkedField",
  "name": "custom_date_values",
  "plural": true,
  "selections": [
    (v47/*: any*/),
    {
      "alias": "typeId",
      "args": null,
      "kind": "ScalarField",
      "name": "custom_date_type_id",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "concreteType": "custom_select_values",
  "kind": "LinkedField",
  "name": "custom_select_values",
  "plural": true,
  "selections": [
    {
      "alias": "optionId",
      "args": null,
      "kind": "ScalarField",
      "name": "custom_select_option_id",
      "storageKey": null
    },
    {
      "alias": "typeId",
      "args": null,
      "kind": "ScalarField",
      "name": "custom_select_type_id",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "concreteType": "custom_checkbox_values",
  "kind": "LinkedField",
  "name": "custom_checkbox_values",
  "plural": true,
  "selections": [
    (v47/*: any*/),
    {
      "alias": "typeId",
      "args": null,
      "kind": "ScalarField",
      "name": "custom_checkbox_type_id",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "concreteType": "projects",
  "kind": "LinkedField",
  "name": "projects",
  "plural": true,
  "selections": (v38/*: any*/),
  "storageKey": null
},
v53 = {
  "_eq": true
},
v54 = [
  (v2/*: any*/),
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "model",
    "storageKey": null
  },
  (v33/*: any*/)
],
v55 = {
  "alias": null,
  "args": null,
  "concreteType": "accounts",
  "kind": "LinkedField",
  "name": "account",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "clients",
      "kind": "LinkedField",
      "name": "clients",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        (v52/*: any*/)
      ],
      "storageKey": null
    },
    (v52/*: any*/),
    {
      "alias": "projectTemplates",
      "args": [
        {
          "kind": "Literal",
          "name": "where",
          "value": {
            "is_template": (v53/*: any*/)
          }
        }
      ],
      "concreteType": "projects",
      "kind": "LinkedField",
      "name": "projects",
      "plural": true,
      "selections": (v38/*: any*/),
      "storageKey": "projects(where:{\"is_template\":{\"_eq\":true}})"
    },
    {
      "alias": "project_tags",
      "args": [
        {
          "kind": "Literal",
          "name": "where",
          "value": {
            "model": {
              "_eq": "project"
            }
          }
        }
      ],
      "concreteType": "tags",
      "kind": "LinkedField",
      "name": "tags",
      "plural": true,
      "selections": (v54/*: any*/),
      "storageKey": "tags(where:{\"model\":{\"_eq\":\"project\"}})"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "tags",
      "kind": "LinkedField",
      "name": "tags",
      "plural": true,
      "selections": (v54/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "workstreams",
      "kind": "LinkedField",
      "name": "workstreams",
      "plural": true,
      "selections": (v34/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "workstream_id",
  "storageKey": null
},
v57 = [
  {
    "kind": "Literal",
    "name": "where",
    "value": {
      "active": (v53/*: any*/)
    }
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ProjectCreateOutput",
        "kind": "LinkedField",
        "name": "action_project_create",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "projects",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "project_roles",
                "kind": "LinkedField",
                "name": "project_roles",
                "plural": true,
                "selections": [
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "clients",
                "kind": "LinkedField",
                "name": "client",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v6/*: any*/),
                  (v3/*: any*/),
                  (v24/*: any*/),
                  (v25/*: any*/)
                ],
                "storageKey": null
              },
              (v27/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "milestones",
                "kind": "LinkedField",
                "name": "milestones",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v28/*: any*/),
                  (v22/*: any*/),
                  (v29/*: any*/),
                  (v30/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "project_members",
                "kind": "LinkedField",
                "name": "members",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v31/*: any*/)
                ],
                "storageKey": null
              },
              (v32/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "project_workstreams",
                "kind": "LinkedField",
                "name": "project_workstreams",
                "plural": true,
                "selections": [
                  (v35/*: any*/)
                ],
                "storageKey": null
              },
              (v36/*: any*/),
              (v37/*: any*/),
              (v39/*: any*/),
              (v40/*: any*/),
              (v41/*: any*/),
              (v43/*: any*/),
              (v45/*: any*/),
              (v46/*: any*/),
              (v48/*: any*/),
              (v49/*: any*/),
              (v50/*: any*/),
              (v51/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ProjectGroupStats_project"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "DetectedPeopleSection_project"
              }
            ],
            "storageKey": null
          },
          (v55/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ProjectCreateOutput",
        "kind": "LinkedField",
        "name": "action_project_create",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "projects",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "project_roles",
                "kind": "LinkedField",
                "name": "project_roles",
                "plural": true,
                "selections": [
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "clients",
                "kind": "LinkedField",
                "name": "client",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v6/*: any*/),
                  (v3/*: any*/),
                  (v24/*: any*/),
                  (v25/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "internal",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "website",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v27/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "milestones",
                "kind": "LinkedField",
                "name": "milestones",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v28/*: any*/),
                  (v22/*: any*/),
                  (v29/*: any*/),
                  (v30/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "project_members",
                "kind": "LinkedField",
                "name": "members",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v31/*: any*/),
                  (v23/*: any*/),
                  (v22/*: any*/),
                  (v56/*: any*/),
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "just_added_timestamp",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              },
              (v32/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "project_workstreams",
                "kind": "LinkedField",
                "name": "project_workstreams",
                "plural": true,
                "selections": [
                  (v35/*: any*/),
                  (v56/*: any*/)
                ],
                "storageKey": null
              },
              (v36/*: any*/),
              (v37/*: any*/),
              (v39/*: any*/),
              (v40/*: any*/),
              (v41/*: any*/),
              (v43/*: any*/),
              (v45/*: any*/),
              (v46/*: any*/),
              (v48/*: any*/),
              (v49/*: any*/),
              (v50/*: any*/),
              (v51/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "accounts",
                "kind": "LinkedField",
                "name": "account",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "default_full_time_minutes",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "v_summary_total",
                "kind": "LinkedField",
                "name": "summary",
                "plural": true,
                "selections": [
                  (v23/*: any*/),
                  (v56/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "total_billable_minutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "total_nonbillable_minutes",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v57/*: any*/),
                "concreteType": "ext_project_link",
                "kind": "LinkedField",
                "name": "ext_project_links",
                "plural": true,
                "selections": [
                  (v22/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "ext_project_id",
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  {
                    "alias": "external_id",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "ext_project_id",
                    "storageKey": null
                  },
                  {
                    "alias": "external",
                    "args": null,
                    "concreteType": "ext_project",
                    "kind": "LinkedField",
                    "name": "ext_project",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "remote_url",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "remote_id",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "integration_id",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ext_project",
                    "kind": "LinkedField",
                    "name": "ext_project",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "where",
                            "value": {
                              "deleted": {
                                "_eq": false
                              }
                            }
                          }
                        ],
                        "concreteType": "ext_project_member",
                        "kind": "LinkedField",
                        "name": "ext_project_members",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ext_person",
                            "kind": "LinkedField",
                            "name": "ext_person",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "first_name",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "last_name",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "email",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "is_placeholder",
                                "storageKey": null
                              },
                              (v6/*: any*/),
                              {
                                "alias": null,
                                "args": (v57/*: any*/),
                                "concreteType": "ext_person_link",
                                "kind": "LinkedField",
                                "name": "ext_person_links",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "ext_person_id",
                                    "storageKey": null
                                  },
                                  (v31/*: any*/),
                                  (v6/*: any*/)
                                ],
                                "storageKey": "ext_person_links(where:{\"active\":{\"_eq\":true}})"
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "ext_project_members(where:{\"deleted\":{\"_eq\":false}})"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "integration",
                        "kind": "LinkedField",
                        "name": "integration",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "integration_service",
                            "kind": "LinkedField",
                            "name": "integration_service",
                            "plural": false,
                            "selections": (v26/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "ext_project_links(where:{\"active\":{\"_eq\":true}})"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "has_actuals",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "priority",
                "storageKey": null
              },
              {
                "alias": "total_budget",
                "args": null,
                "kind": "ScalarField",
                "name": "total_budget_private",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "expenses_budget",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v55/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c24d96314094d535b8f8e8dcd339e61e",
    "id": null,
    "metadata": {},
    "name": "ProjectCreateMutation",
    "operationKind": "mutation",
    "text": "mutation ProjectCreateMutation(\n  $input: ProjectCreateInput!\n  $todaysDate: date!\n) {\n  action_project_create(input: $input) {\n    project {\n      id\n      name\n      account_id\n      client_id\n      active\n      calc_end_date\n      calc_start_date\n      created_at\n      rate_card_id\n      references\n      team_id\n      confirmed\n      is_template\n      tags\n      workstreams_computed\n      pricing_model_readable\n      pricing_model\n      emoji\n      archivable\n      project_roles {\n        estimated_minutes\n        project_id\n        role_id\n      }\n      client {\n        id\n        active\n        name\n        image_key\n        real_client\n      }\n      team {\n        id\n        name\n      }\n      milestones {\n        id\n        date: date_runn\n        project_id\n        note\n        icon\n      }\n      members {\n        id\n        person_id\n      }\n      project_rates {\n        id\n        role_id\n        project_id\n        rate: rate_private\n      }\n      project_workstreams {\n        workstream {\n          id\n          name\n          archived\n        }\n      }\n      phases {\n        id\n        name\n        start_date: start_date_runn\n        end_date: end_date_runn\n        color\n        project_id\n      }\n      other_costs(order_by: {date: asc}) {\n        id\n        project_id\n        charge\n        cost\n        date: date_runn\n      }\n      managers {\n        id\n        user_id\n        project {\n          id\n        }\n      }\n      rate_card {\n        id\n        role_charge_out_rates {\n          role_id\n          rate_card_id\n          charge_out_rate: charge_out_rate_private\n        }\n      }\n      links {\n        id\n        name\n        href\n        show_in_planner\n      }\n      actuals_aggregate {\n        aggregate {\n          count\n        }\n      }\n      assignments_aggregate {\n        aggregate {\n          count\n        }\n      }\n      future_assignments_aggregate: assignments_aggregate(where: {end_date_iso: {_gte: $todaysDate}}) {\n        aggregate {\n          count\n        }\n      }\n      custom_text_values {\n        value\n        typeId: custom_text_type_id\n      }\n      custom_date_values {\n        value\n        typeId: custom_date_type_id\n      }\n      custom_select_values {\n        optionId: custom_select_option_id\n        typeId: custom_select_type_id\n      }\n      custom_checkbox_values {\n        value\n        typeId: custom_checkbox_type_id\n      }\n      ...ProjectGroupStats_project\n      ...DetectedPeopleSection_project\n    }\n    account {\n      id\n      clients {\n        id\n        projects {\n          id\n        }\n      }\n      projects {\n        id\n      }\n      projectTemplates: projects(where: {is_template: {_eq: true}}) {\n        id\n      }\n      project_tags: tags(where: {model: {_eq: \"project\"}}) {\n        id\n        name\n        model\n        archived\n      }\n      tags {\n        id\n        name\n        model\n        archived\n      }\n      workstreams {\n        id\n        name\n        archived\n      }\n    }\n  }\n}\n\nfragment ChangeProjectRoleModal_project on projects {\n  id\n  name\n  members {\n    id\n    role_id\n  }\n}\n\nfragment ChangeWorkstreamModal_project on projects {\n  id\n  name\n  project_workstreams {\n    workstream {\n      id\n      name\n      archived\n    }\n  }\n}\n\nfragment CreateProjectFromTemplateForm_project on projects {\n  id\n  name\n  tags\n  workstreams_computed\n  pricing_model\n  client_id\n  rate_card_id\n  team_id\n  custom_text_values {\n    value\n    typeId: custom_text_type_id\n  }\n  custom_date_values {\n    value\n    typeId: custom_date_type_id\n  }\n  custom_select_values {\n    optionId: custom_select_option_id\n    typeId: custom_select_type_id\n  }\n  custom_checkbox_values {\n    typeId: custom_checkbox_type_id\n    value\n  }\n  ...ProjectCustomEditor_project\n}\n\nfragment CreateTemplateFromProjectForm_project on projects {\n  id\n  name\n  tags\n  workstreams_computed\n  active\n  pricing_model\n  client_id\n  rate_card_id\n  team_id\n  custom_text_values {\n    value\n    typeId: custom_text_type_id\n  }\n  custom_date_values {\n    value\n    typeId: custom_date_type_id\n  }\n  custom_select_values {\n    optionId: custom_select_option_id\n    typeId: custom_select_type_id\n  }\n  custom_checkbox_values {\n    typeId: custom_checkbox_type_id\n    value\n  }\n  ...ProjectCustomEditor_project\n}\n\nfragment DetectedPeopleSection_project on projects {\n  id\n  members {\n    id\n    person_id\n  }\n  ...ProjectGroupRow_project\n  ...ProjectDetailsDetectedPersonRow_project\n  ...DetectedPersonRows_project\n  ext_project_links(where: {active: {_eq: true}}) {\n    ext_project_id\n    project_id\n    ext_project {\n      id\n      integration {\n        id\n        integration_service {\n          id\n          name\n        }\n      }\n      ext_project_members(where: {deleted: {_eq: false}}) {\n        id\n        ext_person {\n          id\n          first_name\n          last_name\n          email\n          is_placeholder\n          active\n          ext_person_links(where: {active: {_eq: true}}) {\n            ext_person_id\n            person_id\n            active\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment DetectedPersonRows_project on projects {\n  id\n  members {\n    id\n    person_id\n  }\n  ...ProjectDetailsDetectedPersonRow_project\n  ext_project_links(where: {active: {_eq: true}}) {\n    ext_project_id\n    project_id\n    ext_project {\n      id\n      ext_project_members(where: {deleted: {_eq: false}}) {\n        id\n        ext_person {\n          id\n          ...ProjectDetailsDetectedPersonRow_extPerson\n          ext_person_links(where: {active: {_eq: true}}) {\n            ext_person_id\n            person_id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment EditProjectForm_project on projects {\n  id\n  name\n  managers {\n    id\n    user_id\n    project {\n      id\n    }\n  }\n  tags\n  workstreams_computed\n  confirmed\n  active\n  pricing_model\n  references\n  client_id\n  rate_card_id\n  team_id\n  is_template\n  emoji\n  custom_text_values {\n    value\n    typeId: custom_text_type_id\n  }\n  custom_date_values {\n    value\n    typeId: custom_date_type_id\n  }\n  custom_select_values {\n    optionId: custom_select_option_id\n    typeId: custom_select_type_id\n  }\n  custom_checkbox_values {\n    typeId: custom_checkbox_type_id\n    value\n  }\n  members {\n    id\n    project_id\n    workstream_id\n  }\n  links {\n    id\n    name\n    href\n    show_in_planner\n  }\n  ...ProjectCustomEditor_project\n  ...ExtLinks_Project\n}\n\nfragment ExtLinks_Project on projects {\n  ext_project_links(where: {active: {_eq: true}}) {\n    project_id\n    ext_project_id\n    active\n    external_id: ext_project_id\n    external: ext_project {\n      id\n      __typename\n      name\n      remote_url\n      remote_id\n      integration_id\n    }\n  }\n}\n\nfragment PersonPlannerMenu_project on projects {\n  id\n  name\n  project_workstreams {\n    workstream_id\n  }\n  ...ChangeProjectRoleModal_project\n  ...RemoveMembershipFromProjectMenuItem_project\n  ...ChangeWorkstreamModal_project\n}\n\nfragment PlaceholderPlannerMenu_project on projects {\n  id\n  name\n  is_template\n  project_workstreams {\n    workstream_id\n  }\n  ...ChangeWorkstreamModal_project\n  ...ChangeProjectRoleModal_project\n}\n\nfragment PlannerLeftColumn_project on projects {\n  id\n  name\n  confirmed\n  is_template\n  created_at\n  calc_start_date\n  archivable\n  has_actuals\n  tags\n  active\n  priority\n  pricing_model\n  total_budget: total_budget_private\n  expenses_budget\n  emoji\n  client {\n    id\n    name\n    image_key\n    website\n    real_client\n    internal\n  }\n  members {\n    id\n    person_id\n  }\n  project_roles {\n    id\n    role_id\n    estimated_minutes\n  }\n  custom_text_values {\n    value\n    typeId: custom_text_type_id\n  }\n  custom_select_values {\n    optionId: custom_select_option_id\n    typeId: custom_select_type_id\n  }\n  custom_checkbox_values {\n    value\n    typeId: custom_checkbox_type_id\n  }\n  custom_date_values {\n    value\n    typeId: custom_date_type_id\n  }\n  actuals_aggregate {\n    aggregate {\n      count\n    }\n  }\n  assignments_aggregate {\n    aggregate {\n      count\n    }\n  }\n  links {\n    id\n    name\n    href\n    show_in_planner\n  }\n  future_assignments_aggregate: assignments_aggregate(where: {end_date_iso: {_gte: $todaysDate}}) {\n    aggregate {\n      count\n    }\n  }\n  ext_project_links(where: {active: {_eq: true}}) {\n    project_id\n    ext_project_id\n  }\n  ...PersonPlannerMenu_project\n  ...PlaceholderPlannerMenu_project\n  ...ProjectLine_project\n  ...ProjectMilestones_project\n  ...EditProjectForm_project\n  ...CreateProjectFromTemplateForm_project\n  ...CreateTemplateFromProjectForm_project\n  ...ViewExternalProjectLink_project\n}\n\nfragment ProjectCustomEditor_project on projects {\n  id\n  custom_text_values {\n    value\n    typeId: custom_text_type_id\n  }\n  custom_date_values {\n    value\n    typeId: custom_date_type_id\n  }\n  custom_select_values {\n    optionId: custom_select_option_id\n    typeId: custom_select_type_id\n  }\n  custom_checkbox_values {\n    value\n    typeId: custom_checkbox_type_id\n  }\n}\n\nfragment ProjectDetailsDetectedPersonRow_extPerson on ext_person {\n  id\n  first_name\n  last_name\n  email\n  is_placeholder\n  active\n}\n\nfragment ProjectDetailsDetectedPersonRow_project on projects {\n  id\n  name\n  ...PlannerLeftColumn_project\n}\n\nfragment ProjectGroupMembersDisplay_project on projects {\n  id\n  name\n  is_template\n  ext_project_links(where: {active: {_eq: true}}) {\n    project_id\n    ext_project_id\n  }\n  project_workstreams {\n    workstream_id\n  }\n}\n\nfragment ProjectGroupRow_project on projects {\n  id\n  ...ProjectGroupMembersDisplay_project\n}\n\nfragment ProjectGroupStats_project on projects {\n  id\n  is_template\n  pricing_model\n  account {\n    id\n    default_full_time_minutes\n  }\n  client {\n    id\n    internal\n  }\n  summary {\n    role_id\n    workstream_id\n    total_billable_minutes\n    total_nonbillable_minutes\n  }\n  project_roles {\n    id\n    role_id\n    estimated_minutes\n  }\n  project_rates {\n    id\n    role_id\n    rate: rate_private\n  }\n}\n\nfragment ProjectLine_project on projects {\n  id\n  confirmed\n  pricing_model\n  calc_start_date\n  calc_end_date\n}\n\nfragment ProjectMilestones_project on projects {\n  id\n  is_template\n  confirmed\n  pricing_model\n  milestones {\n    id\n    project_id\n    title\n    icon\n    date: date_runn\n    note\n  }\n}\n\nfragment RemoveMembershipFromProjectMenuItem_project on projects {\n  id\n  name\n  members {\n    id\n    project_id\n    person_id\n    workstream_id\n    role_id\n  }\n}\n\nfragment ViewExternalProjectLink_project on projects {\n  id\n  ...ExtLinks_Project\n}\n"
  }
};
})();

(node as any).hash = "543bc929e3af5ac718e7867e03878aab";

export default node;
